import { defineComponent } from 'vue';
import AnnualEnvironmentComponent from '@/components/AnnualEnvironment/AnnualEnvironmentComponent.vue';
export default defineComponent({
    name: 'AnnualEnvironment',
    components: { AnnualEnvironmentComponent },
    data() {
        return {};
    }
});
